import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="element-wrapper">
                    <img
                        className="element-6"
                        alt="Element"
                        src="https://c.animaapp.com/mdgpppf7nmySsB/img/----------2.png"
                    />
                </div>
                <div className="footer-text">
                    <p>© 2025 Страховая компания “*****”</p>
                    <p>Все права защищены</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
